import {NgModule} from '@angular/core';
import {MarkAsteriskDirective} from './mark-asterisk.directive';

@NgModule({
  declarations: [MarkAsteriskDirective],
  exports: [MarkAsteriskDirective],
})
export class AsteriskModule {}
